export default __webpack_public_path__ + "images/f52e815ecffff0788796555212df765d.png";